import "./App.css";
import Manager from "./Manager";

function App() {
  return (
    <div className="App">
      <Manager />
    </div>
  );
}

export default App;
